export default {
  "content": "<g fill=\"#3F4450\" fill-rule=\"evenodd\"><path d=\"M6 11A5 5 0 106 1a5 5 0 000 10zm0 1A6 6 0 116 0a6 6 0 010 12z\" opacity=\".5\"/><circle cx=\"6\" cy=\"6\" r=\"4\"/></g>",
  "attrs": {
    "height": "12",
    "viewBox": "0 0 12 12",
    "width": "12",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};